import React, { useEffect, useState } from "react";
import "./About.css";
import Lottie from "lottie-react";
import aboutContactUsAnimation from "../assests/aboutContactUs.json";
import techAnimation from "../assests/aboutUsAnimation.json";
import weFollowAnimation from "../assests/weFollowAnimation.json";
// import { useEffect } from "react";
import { useLocation } from "react-router-dom";
function About() {
  const location = useLocation();

  useEffect(() => {
    const shouldScrollToContact = location.state?.scrollTo === "contact";

    if (shouldScrollToContact) {
      const scrollToContact = () => {
        const section = document.getElementById("contact-section");
        if (section) {
          section.scrollIntoView({ behavior: "auto", block: "start" });
        }
      };

      scrollToContact();
      const timeoutId = window.setTimeout(scrollToContact, 60);

      return () => window.clearTimeout(timeoutId);
    }
  }, [location]);

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="about-container">
      <div className="techHero">
        <div className="topCurve"></div>
        <div className="techCardFull">
          <div className={`logo_curve1 ${isScrolled ? "logo_curve1_scrolled" : ""}`}></div>
          <div className={`logo_curve2 ${isScrolled ? "logo_curve2_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve1 ${isScrolled ? "menu-icon-curve1_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve2 ${isScrolled ? "menu-icon-curve2_scrolled" : ""}`}></div>
          <div className="menu-icon-curve1_MV"></div>
          <div className="menu-icon-curve2_MV"></div>
            <div className="logo_curve1_Mo"></div>
            <div className="logo_curve2_Mo"></div>
                            <div className="techContent_M">
            <h1 className="tech-title1_M about_us_title">ABOUT<br/><span>US</span></h1>
          </div>
          <div className="tech-animationa">
            <Lottie animationData={techAnimation} loop={true} speed={0.1} />
          </div>
        </div>
      </div>
      <div className="goalSection">
  <h1 className="goalTitle">Our Goal</h1>
  <p className="goalText">
    To help startups validate business hypothesis. Rapidly but without quality loss.
    Be it a mobile app, web or desktop app idea - you can test this out by creating
    an MVP - the very first product version you can deliver to market.
  </p>
</div>
<div className="followSection">
  <h1 className="followTitle">WE FOLLOW</h1>

  <p className="followText">
    Quinterra Soft was founded with the concept of Product in mind. This allows us to focus on what
    truly adds value and on our commitment to our partners. Our strong desire to see the Product
    succeed drives our efforts and inspires our creativity. This is our foundation, which drives our
    business, our culture, and everything we do.
  </p>
</div>
      <div className="wf-card-grid">
        <div className="wf-card">
        <div className="wf-animation-box">
          <Lottie animationData={weFollowAnimation} loop={true} />
        </div>
        </div>
        <div className="wf-card">
          <h3 className="wf-card-title">Creativity that explores all options</h3>
          <p className="wf-card-text">
            We see what others do not. Our passion to innovate, drives our creativity.
            We build custom solutions, uniquely designed to drive your vision and success.
          </p>
        </div>

        <div className="wf-card">
          <h3 className="wf-card-title">Strong partnerships, built to last</h3>
          <p className="wf-card-text">
            Relationships matter to us. As an extension of your team, we help shape your future.
            We work best when we align with your goals, and share your vision.
          </p>
        </div>

        <div className="wf-card">
          <h3 className="wf-card-title">Transparently, we work together for the future</h3>
          <p className="wf-card-text">
            Transparency is a natural state of mind. We believe that openness builds trust
            and forms the foundation of every relationship.
          </p>
        </div>

        <div className="wf-card">
          <h3 className="wf-card-title">Success happens when we come and stay together</h3>
          <p className="wf-card-text">
            Henry Ford said, “working together is success.” We partner with clients long-term,
            creating an unparalleled design experience.
          </p>
        </div>

        <div className="wf-card">
          <h3 className="wf-card-title">Quality is a core tenet, never an afterthought</h3>
          <p className="wf-card-text">
            Natural. Organic. Sustainably made. 100% QA’d. It’s the simple formula that drives
            everything we do, and it works every time.
          </p>
        </div>

      </div>
      <div className="contactPage" id="contact-section">
      <div className="contactLeft">
        <h1>Contact Us</h1>

        <p>
          Give us a call or drop by anytime, we endeavour to answer all enquiries
          within 24 hours on business days. We will be happy to answer your questions.
        </p>
        <div className="contactAnimation">
          <Lottie animationData={aboutContactUsAnimation} loop={true} />
        </div>
      </div>
      <div className="contactRight">
        <h2>Ready to Get Started?</h2>
        <p className="contactNote">
          Your email address will not be published. Required fields are marked *
        </p>
        <form className="contactForm">
          <input type="text" placeholder="Your Name*" />
          <input type="email" placeholder="Email*" />
          <textarea placeholder="Message..."></textarea>

          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
    </div>
  );
}

export default About;
